import { abs } from 'mathjs'

export function roundToSmartPrecision(number: number) {
    return number.toFixed(abs(number) >= 10 ? 0 : abs(number) >= 1 ? 1 : 2)
}

export const formatProfitPercentage = (profit: number, margin: number): string => {
    if (!margin || !isFinite(profit)) return ''
    const percentage = roundToSmartPrecision((profit / margin) * 100)
    return `+${percentage}%`
}

export const formatLossPercentage = (loss: number, margin: number): string => {
    if (!margin || !isFinite(loss)) return ''
    const percentage = roundToSmartPrecision((Math.abs(loss) / margin) * 100)
    return `-${percentage}%`
}

export const formatBreakevenPercentage = (breakeven: number, spotPrice: number): string => {
    if (!spotPrice) return ''
    const percentage = roundToSmartPrecision(((breakeven - spotPrice) / spotPrice) * 100)
    return `${percentage}%`
}
